import {Button, Chip} from "@mui/material";
import {Link} from "react-router-dom";
import {AdjustCol, RenderFilterProps, RenderStringCol2} from "../../../../misc/scroller/Table";
import {LogiCtrlExistingItem} from "../../../../api/LogiCtrl";
import {SelectFilterForCol} from "../../../../misc/SelectFilterForCol";

// keeps the buttons and chip inside the table's row height
const inlineSx = {py: 0, px: 0.75, minHeight: 0, lineHeight: 1.3, fontSize: 12, textTransform: "none"} as const;

// the draft / price-request PO the request is on, linked
export function PoCol() {
    return RenderStringCol2<LogiCtrlExistingItem>("PO", v => v.purchaseOrder ? `PO #${v.purchaseOrderNumber}` : "", v => {
        if(!v.purchaseOrder) return "";
        return <Link target="_blank" to={`/logistics/purchasing/${v.purchaseOrder}`}>PO #{v.purchaseOrderNumber}</Link>;
    }, 100);
}

const yesNoList = ["Yes", "No"];

// Review button for a released / draft-PO request, or the approval with a Clear button.
// The Yes/No filter is on whether the row needs (or has) a PO review at all.
export function PoReviewCol(props: {
    onReview(item: LogiCtrlExistingItem): void;
    onClear(item: LogiCtrlExistingItem): void;
    clearing: boolean;
}) {
    return AdjustCol(RenderStringCol2<LogiCtrlExistingItem>("PO Review", v => {
        if(!v.poModifyRequired) return "";
        return v.poModifyApproved ? "approved" : "review";
    }, v => {
        if(!v.poModifyRequired) return "";

        if(v.poModifyApproved) {
            return <div style={{display: "flex", alignItems: "center", gap: 4}}>
                <Chip size="small" color="info" sx={{height: 18, fontSize: 11}} label={v.purchaseOrder ? "Will modify PO" : "Will re-release"} />
                <Button size="small" variant="text" sx={inlineSx} disabled={props.clearing} onClick={() => props.onClear(v)}>Clear</Button>
            </div>;
        }

        return <Button size="small" variant="outlined" color="warning" sx={inlineSx} onClick={() => props.onReview(v)}>Review</Button>;
    }, 170), {
        filter: (row: LogiCtrlExistingItem, input: string) => {
            const str = input.toLowerCase().trim();
            if(str === "yes") return row.poModifyRequired;
            if(str === "no") return !row.poModifyRequired;
            return true;
        },
        renderFilter: (p: RenderFilterProps) => <SelectFilterForCol value={p.value} onChange={p.onChange} list={yesNoList} />,
    });
}

export function poModifyRowColor(row: LogiCtrlExistingItem, approvedColor: string, pendingColor: string) {
    if(row.poModifyRequired && !row.poModifyApproved) return pendingColor;
    if(row.poModifyRequired && row.poModifyApproved) return approvedColor;
    return null;
}
